<script lang="ts">
	import CustomBold from '$lib/portableText/customBold.svelte';
	import CustomList from '$lib/portableText/customList.svelte';
	import CustomListItem from '$lib/portableText/customListItem.svelte';
	import { PortableText } from '@portabletext/svelte';
	import type { InputValue } from '@portabletext/svelte';
	import GreenLink from './greenLink.svelte';
	import Link from './link.svelte';
	import Paragraph from './paragraph.svelte';
	import CustomHighlight from '$lib/portableText/customHighlight.svelte';
	import SimpleParagraph from './simpleParagraph.svelte';

	type LinkStyle = 'underline' | 'green';
	type ParagraphStyle = 'simple' | 'normal';

	interface Props {
		content: InputValue;
		linkStyle?: LinkStyle;
		paragraphStyle?: ParagraphStyle;
	}

	let { content, linkStyle = 'underline', paragraphStyle = 'normal' }: Props = $props();
</script>

<PortableText
	value={content}
	components={{
		block: {
			normal: paragraphStyle === 'simple' ? SimpleParagraph : Paragraph
		},
		list: CustomList,
		listItem: { bullet: CustomListItem, number: CustomListItem, normal: CustomListItem },
		marks: {
			// @ts-ignore
			link: linkStyle === 'underline' ? Link : GreenLink,
			strong: CustomBold,
			highlight: CustomHighlight
		}
	}}
/>
